/*
 * @Author: zhangsheng
 * @Date: 2023-09-18 16:17:15
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-10-07 16:48:23
 * @FilePath: \panda-index-sicermem-frontend\src\locales\zh-CN\product.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
  'components.ProductIntroduce.976335-1': '产品参数',
  'components.ProductIntroduce.976335-2': '产品介绍',
  'components.ProductIntroduce.976335-3': '技术参数',
  'components.ProductIntroduce.976335-4': '产品优势',
  'components.ProductIntroduce.976335-5': 'W膜元件',
  'components.ProductIntroduce.976335-6': '查看更多',
  'components.ProductIntroduce.976335-7': '收起',
  'components.ProductIntroduce.976335-8': '返回',
  'components.ProductIntroduce.976335-9': '/product',
  'components.ProductIntroduce.976335-10': '/product/detail',
};
